const actions = {

};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/payment/actions.js